import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Danat_Al_Emarat.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Danat Al Emarat Hospital</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A specialist hospital in Abu Dhabi providing advanced maternity, women's health and paediatric care. One of a select number
                of projects where GEMCO engaged directly with the client — underscoring the company's capability to deliver retrofit MEP
                works independently.</p>
              <p>MAIN CONTRACTOR : Direct Client Engagement</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : Various retrofit MEP works and supply — direct client engagement</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one